'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Tooltip } from '@/components/elementary/Tooltip';
import { Copy } from '@/components/icons/social/Copy';
import { Button } from '@/components/ui/button';
import { COPY_CONTENT_TEST_IDS } from '@/lib/test-ids';
export const CopyContent = t0 => {
  const $ = _c(12);
  const {
    shareUrl
  } = t0;
  const [copied, setCopied] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const t = useTranslations("CopyContent");
  let t1;
  if ($[0] !== shareUrl) {
    t1 = async () => {
      ;
      try {
        await navigator.clipboard.writeText(shareUrl);
        setTooltipOpen(true);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
          setTooltipOpen(false);
        }, 2000);
      } catch (t2) {
        const err = t2;
        console.error("Failed to copy:", err);
      }
    };
    $[0] = shareUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  const t2 = copied ? "copied" : "label";
  let t3;
  if ($[2] !== t || $[3] !== t2) {
    t3 = t(t2);
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Copy className="text-neutral-light-alpha-500" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleCopy) {
    t5 = <Button onClick={handleCopy} size="none" aria-label="Copy Link" variant="none" data-test-id={COPY_CONTENT_TEST_IDS.COMPONENT}>{t4}</Button>;
    $[6] = handleCopy;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5 || $[10] !== tooltipOpen) {
    t6 = <Tooltip content={t3} open={tooltipOpen} onOpenChange={setTooltipOpen} asChild={true}>{t5}</Tooltip>;
    $[8] = t3;
    $[9] = t5;
    $[10] = tooltipOpen;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};